export default __webpack_public_path__ + "static/media/SuperPlantBasedClub.b0687a23.jpg";